import React from 'react';

const Steps = () => {
  const steps = [
    {
      title: "Ürünü Seç",
      description: "Teklif almak istediğiniz ürünü seçin.",
      icon: "faq" // İlk adım için FAQ ikonu
    },
    {
      title: "Bilgilerinizi Girin",
      description: "Size özel teklifler almak için bilgilerinizi girin.",
      icon: "resume" // İkinci adım için resume ikonu
    },
    {
      title: "Size Ulaşalım",
      description: "Yetkili sigorta uzmanımız en kısa sürede size ulaşsın.",
      icon: "service" // Üçüncü adım için service ikonu
    },
  ];

  const getIconPath = (iconName) => {
    const iconPaths = {
      faq: "/why/faq.png",
      resume: "/why/resume.png",
      service: "/why/service.png"
    };
    return iconPaths[iconName];
  };

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-4xl font-bold mb-16">
          <span className="text-[#0083ff]">sigortamolsun.com</span> Her Adımda Yanınızda
        </h2>

        <div className="flex flex-col md:flex-row justify-center items-center gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-white border border-gray-200 shadow-lg rounded-lg p-8 text-center flex-1"
              style={{ maxWidth: '300px', minHeight: '300px' }}
            >
              {/* Adım Numarası */}
              <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-[#3b82f6] text-white rounded-full w-10 h-10 flex items-center justify-center text-lg font-semibold">
                {index + 1}
              </div>

              {/* İkon Alanı */}
              <div className="w-20 h-20 mx-auto mb-4 bg-[#f5f6ff] rounded-full flex items-center justify-center shadow-md">
                <img 
                  src={getIconPath(step.icon)}
                  alt={step.title}
                  className="w-12 h-12 object-contain"
                />
              </div>

              {/* Başlık */}
              <h3 className="text-xl font-semibold text-gray-800 mb-2">{step.title}</h3>

              {/* Açıklama */}
              <p className="text-gray-600 text-sm">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Steps;